import { render, staticRenderFns } from "./LoanCarousel.vue?vue&type=template&id=23c37d4b&"
import script from "./LoanCarousel.vue?vue&type=script&lang=js&"
export * from "./LoanCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports